import {Injectable} from '@angular/core';
import {ProductParameterFormatImageState, Store as ProductParameterFormatImageStore} from './store';
import {EntityService} from '../../../components/entity-service';
import {ProductParameterFormatImage} from './model';
import {FieldConfig} from '../../../components/form/field.interface';
import {Validators} from '@angular/forms';
import {TranslocoService} from '@ngneat/transloco';
import {map, shareReplay, switchMap} from 'rxjs/operators';
import {ProductParameterFormatImageQuery} from './query';

@Injectable({ providedIn: 'root' })
export class ProductParameterFormatImageService extends EntityService<ProductParameterFormatImageStore, ProductParameterFormatImageState> {

  ProductParameterFormatImages$ = this.get().pipe(
    switchMap(() => this.query.selectAll()),
    map(items => items.map(item => new ProductParameterFormatImage(item)).sort((u1, u2) => u1.toString() > u2.toString() ? 1 : -1)),
    shareReplay(1)
  );
  editForm = {
    cancelTitle: this.translocoService.selectTranslate('form.cancel'),
    submitTitle: this.translocoService.selectTranslate('form.submit'),
    entityTitle: this.translocoService.selectTranslate('ProductParameterFormatImage.entityTitle'),
    fields: [
      FieldConfig.create({
        type: 'input',
        label: this.translocoService.selectTranslate('ProductParameterFormatImage.name'),
        inputType: 'text',
        name: 'format',
        listed: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
      FieldConfig.create({
        type: 'input',
        label: this.translocoService.selectTranslate('ProductParameterFormatImage.name'),
        inputType: 'text',
        name: 'productParameterType',
        listed: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
      FieldConfig.create({
        type: 'input',
        label: this.translocoService.selectTranslate('ProductParameterFormatImage.name'),
        inputType: 'text',
        name: 'image',
        listed: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
    ]
  };

  constructor(
    protected translocoService: TranslocoService,
    private query: ProductParameterFormatImageQuery,
    protected store: ProductParameterFormatImageStore) {
    super(store, ProductParameterFormatImage);
  }

  get resourceName(): string {
    return 'products/product-parameter-format-image';
  }

}
